import React from "react";
import SkeletonLoader from "../../../../../components/skeleton-loader";
import styles from "../styles.module.scss";

const bar = { borderRadius: 6 };

function SkeletonLabelValue({ labelWidth, valueWidth }) {
  return (
    <div className={styles.dataItem}>
      <SkeletonLoader
        component="span"
        variant="rectangular"
        animation="pulse"
        width={labelWidth}
        height={12}
        style={{ ...bar, minHeight: 12 }}
      />
      <div>
        <SkeletonLoader
          variant="rectangular"
          animation="pulse"
          width={valueWidth}
          height={16}
          style={{ ...bar, minHeight: 16 }}
        />
      </div>
    </div>
  );
}

function SkeletonAgentRow() {
  return (
    <div className={styles.dataItem}>
      <SkeletonLoader
        component="span"
        variant="rectangular"
        animation="pulse"
        width="40%"
        height={12}
        style={{ ...bar, minHeight: 12 }}
      />
      <div>
        <SkeletonLoader
          variant="circular"
          animation="pulse"
          width={16}
          height={16}
          style={{ flexShrink: 0 }}
        />
        <SkeletonLoader
          variant="rectangular"
          animation="pulse"
          width="72%"
          height={16}
          style={{ ...bar, minHeight: 16 }}
        />
      </div>
    </div>
  );
}

function SkeletonRefundTable() {
  return (
    <div className={styles.tableContainer}>
      <div className={styles.skeletonRefundTable}>
        <div className={styles.skeletonRefundHeader}>
          {[32, 28, 36].map((w) => (
            <SkeletonLoader
              key={w}
              variant="rectangular"
              animation="pulse"
              width={`${w}%`}
              height={12}
              style={{ ...bar, minHeight: 12 }}
            />
          ))}
        </div>
        {[0, 1, 2].map((i) => (
          <div key={i} className={styles.skeletonRefundRow}>
            <SkeletonLoader
              variant="rectangular"
              animation="pulse"
              width="38%"
              height={14}
              style={{ ...bar, minHeight: 14 }}
            />
            <SkeletonLoader
              variant="rectangular"
              animation="pulse"
              width="42%"
              height={14}
              style={{ ...bar, minHeight: 14 }}
            />
            <SkeletonLoader
              variant="rectangular"
              animation="pulse"
              width="22%"
              height={14}
              style={{ ...bar, minHeight: 14 }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

function SkeletonLineBlock() {
  return (
    <div className={styles.skeletonLineSection}>
      <div className={styles.dataContainer}>
        <SkeletonLabelValue labelWidth="70%" valueWidth="88%" />
        <div className={`${styles.dataItem} ${styles.dataItemSpan2}`}>
          <SkeletonLoader
            component="span"
            variant="rectangular"
            animation="pulse"
            width="45%"
            height={12}
            style={{ ...bar, minHeight: 12 }}
          />
          <div>
            <SkeletonLoader
              variant="rectangular"
              animation="pulse"
              width="95%"
              height={16}
              style={{ ...bar, minHeight: 16 }}
            />
          </div>
        </div>
        <SkeletonLabelValue labelWidth="55%" valueWidth="50%" />
      </div>
      <SkeletonRefundTable />
    </div>
  );
}

function SkeletonHeadingRow() {
  return (
    <div className={styles.skeletonHeadingRow}>
      <SkeletonLoader
        variant="rectangular"
        animation="pulse"
        width={60}
        height={14}
        style={{ ...bar, minHeight: 14, flexShrink: 0 }}
      />
      <SkeletonLoader
        variant="rectangular"
        animation="pulse"
        className={styles.skeletonHeadingLine}
        height={2}
        style={{ ...bar, minHeight: 2 }}
      />
    </div>
  );
}

const PaymentAuthorizationReportSkeleton = () => {
  return (
    <div
      className={styles.skeletonReport}
      aria-busy="true"
      aria-label="Loading report"
    >
      <SkeletonHeadingRow />

      <div className={styles.dataContainer}>
        <SkeletonLabelValue labelWidth="72%" valueWidth="68%" />
        <SkeletonLabelValue labelWidth="38%" valueWidth="76%" />
        <SkeletonLabelValue labelWidth="48%" valueWidth="68%" />
        <SkeletonLabelValue labelWidth="36%" valueWidth="44%" />
        <SkeletonLabelValue labelWidth="64%" valueWidth="82%" />
        <SkeletonLabelValue labelWidth="42%" valueWidth="58%" />
        <SkeletonAgentRow />
        <SkeletonAgentRow />
      </div>

      <SkeletonHeadingRow />

      <SkeletonLineBlock />
      <SkeletonLineBlock />
    </div>
  );
};

export default PaymentAuthorizationReportSkeleton;
